import { useTranslation } from "react-i18next";
var formattingRegex = /(\{\d+\})/gim;
export var useLocalize = function () {
    var t = useTranslation().t;
    var newTFunction = function (key, values) {
        var content = t(key);
        if (values && values.length > 0) {
            var matches = content.match(formattingRegex);
            if (matches && matches.length > 0) {
                matches.forEach(function (template, tempIndex) {
                    content = content.replace(template, values[tempIndex]);
                });
            }
        }
        return content;
    };
    return { t: newTFunction };
};
